export enum CompletePatientTypes {
  Manual = 1,
  Dropbox = 2,
  TagPickupStation = 3,
  AutoCheckoutMaxTimeInDepartment = 4,
  AutoCheckoutMaxTimeNonReporting = 5,
  AutoCheckoutMaxTimeUnassigned = 6,
}
